import * as React from "react";
import {FontAwesomeIcon}        from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp, faRotate} from "@fortawesome/free-solid-svg-icons";

import "./field-results-card.scss";

import {cs}             from "@Common/react/chain-services";
import {UseState}       from "@Common/react/use-state";
import {consumeContext} from "@Common/react/context";
import { ScreenLoader } from "@Common/ui-components/loading-spinners/screen-loader";

export const FieldResultsCard = ({idOrder, item, field, initFieldSuggestions}) => cs(
    consumeContext("apis"),
    ["fieldSuggestions", ({}, next) => UseState({
        _key: initFieldSuggestions,
        initValue: initFieldSuggestions,
        next
    })],
    ["loading", ({fieldSuggestions}, next) => UseState({
        _key: fieldSuggestions,
        initValue: !fieldSuggestions.value?.length,
        next
    })],
    ["fieldIsExpanded", ({}, next) => UseState({
        initValue: true,
        next
    })],
    ["createSuggestionDiv", ({}, next) => next((suggestion) => {
        return (<div className="field-suggestion-div">{suggestion.content}</div>)
    })],
    ["reloadCurrentFieldSuggestions", ({apis, loading, fieldSuggestions}, next) => next(async () => {
        try {
            loading.onChange(true);
            fieldSuggestions.onChange([]);
            const results = await apis.next.gpt.generateFieldSuggestions({
                idOrder: parseInt(idOrder),
                numOfSuggestions: 3,
                idProductType: parseInt(item.idProductType),
                field: {
                    idPrimary: field.idPrimary,
                    fieldKey: field.fieldKey,
                    displayLabel: field.displayLabel,
                    maxLength: field.maxLength,
                    enableLimitOverride: field.enableLimitOverride,
                },
            });
            fieldSuggestions.onChange(results.flat());
            loading.onChange(false);
            return results;
        } catch (error) {
            // TODO: Implement a custom error handler
            console.error("Error fetching property wizard data:", error);
        }
    })],

    ({loading, fieldSuggestions, fieldIsExpanded, createSuggestionDiv, reloadCurrentFieldSuggestions}) => (
        <div className="field-results-card-j63">
            <div className="field-results-card-header">
                <div className="field-label-and-reload">
                    {field.displayLabel}
                    <div
                        className="reload-icon"
                        onClick={() => reloadCurrentFieldSuggestions()}
                    >
                        <FontAwesomeIcon icon={faRotate} />
                    </div>
                </div>
                <div className="field-expand-collapse">
                    <span className="down-chevron">
                        {fieldIsExpanded.value ?
                            <FontAwesomeIcon icon={faChevronUp}
                                onClick={() => fieldIsExpanded.onChange(false)}
                            />
                        :
                            <FontAwesomeIcon icon={faChevronDown}
                                onClick={() => fieldIsExpanded.onChange(true)}
                            />
                        }
                    </span>
                </div>
            </div>
            <div className={fieldIsExpanded.value ? "content" : "content collapsed"}>
                {loading.value ?
                    <div className="page-loader"><ScreenLoader loaderColor="#6937B7"/></div>
                :
                    fieldSuggestions.value?.map((suggestion) => createSuggestionDiv(suggestion))
                }
            </div>
        </div>
    )
);